import { KIND, SIZE } from 'baseui/button'
import { Notification, KIND as NOTIFICATION_KIND } from 'baseui/notification'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { useSnackbar } from 'baseui/snackbar'

import { selectOrganizationsSelectedProvider } from '../organizationsManagementSelectors'
import { nettingUpdaterActions } from './nettingUpdaterSagas'
import { selectNettingUpdaterStoreData } from './nettingUpdaterSelectors'
import {
  ActionsRow,
  NotificationsWrapper,
  HeaderRow,
  ProviderInfo,
} from './styled-components'

const NettingApiForm = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation('organizationManagement')
  const navigate = useNavigate()
  const { enqueue } = useSnackbar()

  const selectedProvider = useSelector(selectOrganizationsSelectedProvider)
  const { isSubmitting, resultError, resultMessage } = useSelector(selectNettingUpdaterStoreData)

  const providerName = selectedProvider?.name || ''

  const hasSuccessMessage = resultMessage && !resultError
  const hasErrorMessage = Boolean(resultError)

  const onSubmit = () => {
    dispatch({
      type: nettingUpdaterActions.SUBMIT_API,
      enqueue,
      t,
      providerId: selectedProvider?.id,
    })
  }

  const onGoBack = () => {
    navigate(-1)
  }

  return (
    <div>
      <HeaderRow>
        <SDButton
          onClick={onGoBack}
          size={SIZE.mini}
          kind={KIND.secondary}
        >
          {t('netting.button_back')}
        </SDButton>
      </HeaderRow>

      <ProviderInfo>
        {t('netting.provider_label')}: <strong>{providerName}</strong>
      </ProviderInfo>

      <ActionsRow>
        <SDButton
          onClick={onSubmit}
          isLoading={isSubmitting}
          disabled={isSubmitting}
          size={SIZE.compact}
        >
          {t('netting.api.button_submit')}
        </SDButton>
      </ActionsRow>

      {hasSuccessMessage && (
        <NotificationsWrapper>
          <Notification
            kind={NOTIFICATION_KIND.positive}
            overrides={{ Body: { style: { width: 'auto', marginLeft: 0 } } }}
          >
            {String(resultMessage)}
          </Notification>
        </NotificationsWrapper>
      )}

      {hasErrorMessage && (
        <NotificationsWrapper>
          <Notification
            kind={NOTIFICATION_KIND.negative}
            overrides={{ Body: { style: { width: 'auto', marginLeft: 0 } } }}
          >
            {String(resultError)}
          </Notification>
        </NotificationsWrapper>
      )}
    </div>
  )
}

export default NettingApiForm
